import "core-js/modules/es.array.push.js";
import Component from "./components";
export default {
    props: {
        modelValue: {
            type: String,
            default: ""
        },
        showExternal: {
            type: Boolean,
            default: false
        }
    },
    components: {
        ...Component
    },
    data () {
        return {
            visible: false,
            url: "",
            selectComponents: "Link",
            data: [],
            defaultProps: {
                children: 'children',
                label: 'label'
            }
        };
    },
    computed: {
        menuData () {
            const baseMenu = [
                {
                    label: '商城链接',
                    components: "Link"
                },
                {
                    label: '商品页面',
                    components: "Goods"
                }
            ];
            if (this.showExternal) {
                baseMenu.push({
                    label: '外部链接',
                    components: "External"
                });
            }
            return baseMenu;
        }
    },
    watch: {
        showExternal: {
            handler () {
                this.data = this.menuData;
            },
            immediate: true
        },
        modelValue: {
            handler (newVal) {
                this.url = newVal;
            },
            immediate: true,
            deep: true
        },
        url (val) {
            this.$emit('update:modelValue', val);
        }
    },
    methods: {
        handleNodeClick (data) {
            if (!data.components) return;
            this.selectComponents = data.components;
        },
        open () {
            this.visible = true;
            return this;
        }
    }
};
